if (!customElements.get('product-card-custom')) {
    customElements.define('product-card-custom', class extends HTMLElement {
        connectedCallback() {
            this.image = this.querySelector('[data-primary-image]');
            this.links = this.querySelectorAll('[data-product-link], .hm-product-card__title-link, .hm-product-card__shop-link');
            this.swatches = this.querySelectorAll('.hm-product-card__swatch[data-product-url]');
            this.swatches.forEach((swatch) => {
                swatch.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (!swatch.dataset.image) {
                        return;
                    }
                    this.selectSwatch(swatch);
                });
            });
        }

        selectSwatch(swatch) {
            if (this.image) {
                this.image.src = swatch.dataset.image;
                if (swatch.dataset.srcset) {
                    this.image.srcset = swatch.dataset.srcset;
                }
            }
            this.links.forEach((link) => {
                link.href = swatch.dataset.productUrl;
            });
            this.swatches.forEach((item) => item.removeAttribute('aria-current'));
            swatch.setAttribute('aria-current', 'true');
        }
    });
}
